import * as S from "./CustomTabTemplate.style";
import { Buttons } from "../../atoms/Buttons";
import { TabList } from "../../molecules/TabList";
import { ReactComponent as IconClose } from "../../../styles/assets/svg/icon_add.svg";

import { ChartTab } from "../../../common/states/chart";
import { memo, useMemo } from "react";
import ChartContent from "../../containers/ChartContent";

interface CustomTabTemplateProps {
  selectedTab: number | null;
  setSelectedTab: any;
  tabs: ChartTab[];
  onContextMenu: (event: React.MouseEvent, target: any) => void;
  addTab: () => void;
  closeTab: (index: number) => void;
  updateTrendId: (trendId: number) => void;
}

const CustomTabTemplate = ({
  selectedTab,
  setSelectedTab,
  tabs,
  onContextMenu,
  addTab,
  closeTab,
  updateTrendId,
}: CustomTabTemplateProps) => {
  // 현재 선택된 탭 찾기
  const currentTab = useMemo(
    () => tabs.find((tab) => tab.index === selectedTab) || tabs[0],
    [tabs, selectedTab]
  );

  // TabList에 전달할 데이터
  const tabListData = useMemo(() => tabs.map((tab) => ({ ...tab })), [tabs]);

  return (
    <S.CustomTabTemplate>
      <S.CustomTabBox>
        <TabList
          onContextMenu={onContextMenu}
          selectedTab={selectedTab ?? 0}
          setSelectedTab={setSelectedTab}
          data={tabListData}
          onClose={closeTab}
          isUseClose={true}
        />
        <Buttons
          type="button"
          size="md-icon"
          layout="secondary"
          icon={<IconClose />}
          onClick={addTab}
        />
      </S.CustomTabBox>

      {currentTab && (
        <ChartContent
          key={`chart-content-${selectedTab}`} // 탭 변경 시 컴포넌트 강제 리렌더링
          trendId={currentTab.trendId}
          updateTrendId={updateTrendId}
          newCharts={currentTab.chartTimes || []}
          newChartOptions={currentTab.chartOptions || []}
          newChartSearch={currentTab.chartSearch || {}}
          selectedTab={selectedTab ?? 0}
        />
      )}
    </S.CustomTabTemplate>
  );
};

export default memo(CustomTabTemplate);
